import { Separator } from 'app/components/ui/Separator'
import { Text } from 'app/components/ui/Text'
import { themeEstra } from 'app/styles/themeEstra'
import React from 'react'
import styled from 'styled-components'

export const CardListItem = ({
  label,
  children,
}: {
  label: string
  children?: React.ReactNode
}) => {
  return children ? (
    <>
      <StyledSeparator
        color={themeEstra.color.neutri.grigioBg}
      ></StyledSeparator>
      <DetailsListItemWrapper>
        <LabelWrapper>
          <Text variant='s20'>{label}:</Text>
        </LabelWrapper>
        {children}
      </DetailsListItemWrapper>
    </>
  ) : null
}

const DetailsListItemWrapper = styled.div`
  display: grid;
  grid-template-columns: 2fr 3fr;
  gap: 4rem;

  @media (max-width: ${({ theme }) => theme.bp.desktop}) {
    gap: 1rem;
  }
`

const LabelWrapper = styled.div`
  display: flex;
  align-items: center;
`

const StyledSeparator = styled(Separator)`
  margin: 1rem 0;
`
